import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getBootcampModulesApi(bootcampId) {
  let apiUrl = `${apiBasePath}/modules?paginated=false`;

  if (bootcampId !== undefined) {
    apiUrl += `&bootcampId=${bootcampId}`;
  }

  const options = {
    method: "GET",
    url: apiUrl,
    data: bootcampId,
  };
  return ApiService(options);
}

export function addBootcampModulesApi(data) {
  let apiUrl = `${apiBasePath}/modules?paginated=false`;

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function deleteBootcampModuleApi(moduleId) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/modules/${moduleId}`,
  };
  return ApiService(options);
}

export function editBootcampModuleApi(data) {
  const options = {
    method: "PATCH",
    url: `${apiBasePath}/modules`,
    data: data,
  };
  return ApiService(options);
}

export function cloneBootcampModulesApi(data) {
  let apiUrl = `${apiBasePath}/modules/clone`;

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}
